/**
 * API Configuration
 * Environment variables and API settings
 */

// Create React App uses process.env.REACT_APP_* for environment variables
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || '';

export const API_CONFIG = {
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'app': 'anstmasr2588',
  },
};

export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';

